// Central SEO component: renders title, description, canonical, Open Graph,
// Twitter cards and optional JSON-LD. React 19 hoists these tags into <head>.
export const SITE = {
  name: 'Nexite IT',
  url: 'https://www.nexite-it.com',
  defaultImage: 'https://www.nexite-it.com/apple-touch-icon.png',
  locale: 'de_DE',
};

const Seo = ({
  title,
  description,
  path = '/',
  image = SITE.defaultImage,
  type = 'website',
  noindex = false,
  jsonLd = null,
}) => {
  const canonical = `${SITE.url}${path}`;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <link rel="canonical" href={canonical} />
      )}

      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:locale" content={SITE.locale} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {schemas.map((schema, index) => (
        <script
          key={index}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
        />
      ))}
    </>
  );
};

export default Seo;
